import styled from '@emotion/styled'

const font = '"Segoe UI", Arial'

export const Container = styled.section`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 80px 15px 0;
  position: relative;

  @media (max-width: 767px) {
    padding-top: 30px;
  }
`

export const Wrapper = styled.div``

export const Content = styled.div``

export const Title = styled.h2`
  font: 400 28px ${font};
  color: #78be20;
  display: flex;
  margin-bottom: 20px;

  span {
    font-weight: 800;
    margin-right: 10px;
  }

  @media (min-width: 968px) {
    font-size: 35px;
  }
`

export const InfoContainer = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`

export const Bar = styled.div`
  display: inline-block;
  width: 150px;
  height: 3px;
  background: #78be20;
  position: relative;
  bottom: 10px;
`

export const Info = styled.p`
  font-family: ${font};
  width: 380px;
  border: 2px solid #eeeef0;
  padding: 30px 25px;
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  border-radius: 20px;
  line-height: 42px;

  strong {
    color: #78be20;
  }

  @media (max-width: 767px) {
    width: 100%;
    font-size: 22px;
    line-height: 36px;
  }
`

export const InfoBox = styled.div<{
  $width?: number | string
  $height?: number | string
}>`
  font-family: ${font};
  width: ${({ $width }) => $width ?? '100%'};
  height: ${({ $height }) => $height ?? '200px'};
  border: 2px solid #eeeef0;
  padding: 20px 25px 15px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  svg {
    margin-bottom: 15px;
  }

  h3 {
    font-size: 20px;
    font-weight: 800;
    line-height: 30px;
    margin-bottom: 4px;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;
  }

  @media (max-width: 767px) {
    width: 100% !important;
    height: auto !important;
  }
`

export const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`

export const InfoRow = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`

export const InfoBottom = styled.div`
  font-family: ${font};
  width: 100%;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;

  h3 {
    font-size: 20px;
    font-weight: 800;
    line-height: 30px;
    margin: 30px 0 15px;
    display: flex;
    align-items: center;
    gap: 20px;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;
    display: flex;

    span {
      display: inline-block;
      width: 800px;
    }

    svg {
      @media (max-width: 767px) {
        width: 345px;
        margin-top: 10px;
      }
    }
  }

  @media (max-width: 767px) {
    p {
      flex-direction: column;

      span {
        width: 100%;
      }
    }
  }
`
export const InfoLink = styled.strong`
  color: #78be20;
`
